import React from 'react'
import { useHomeActiveRequest } from '../../hooks/requests/useHomeActiveRequest'

export default function HomePusherRequests() {
  useHomeActiveRequest()
  return <div></div>
}
